'use client';

import { useSession } from 'next-auth/react';
import { useEffect } from 'react';

/**
 * Background client component that monitors auth session and clears
 * survey-related localStorage when user is not logged in.
 * 
 * This prevents old guest user progress from interfering with new sessions
 * after logout without needing to modify server components.
 * 
 * Works like a cronjob that runs on client-side whenever session changes.
 */
export function SurveyStorageCleaner() {
    const { data: session, status } = useSession();

    useEffect(() => {
        // Only run when session status is determined (not loading)
        if (status === 'loading') return;

        // If no session (user logged out or never logged in), clear survey storage
        if (!session?.user) {
            if (typeof window !== 'undefined') {
                const surveyKeys = [
                    'survey_progress_take-health-quiz',
                    'survey_restart_group_take-health-quiz',
                    'survey_session_take-health-quiz'
                ];

                // Check if any keys exist before clearing
                const hasKeys = surveyKeys.some(key => localStorage.getItem(key) !== null);
                
                if (hasKeys) {
                    surveyKeys.forEach(key => {
                        localStorage.removeItem(key);
                        console.log(`🗑️ [SurveyStorageCleaner] Cleared ${key} (no active session)`);
                    });
                    console.log('✅ [SurveyStorageCleaner] Survey localStorage cleared automatically');
                }
            }
        }
    }, [session, status]);

    // This component doesn't render anything
    return null;
}
